import { getEnumValuesFromPipelineSchema } from '@flows/configs/shared/schemaUtils'
import { BaseSchema_LiabilityV1GetsafeDe as schema } from '@flows/insurance/schemas'

const deductibleOptionsFromSchema = getEnumValuesFromPipelineSchema(schema.shape.deductible_amount)

export const LIABILITY_CONSTANTS = {
  deductibleOptions: deductibleOptionsFromSchema,
}
